import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { DbMeal } from '@/types/database';

export function useMeals(category?: string) {
  return useQuery({
    queryKey: ['meals', category],
    queryFn: async () => {
      let query = supabase
        .from('meals')
        .select('*')
        .eq('is_active', true)
        .order('name_he');

      if (category && category !== 'all') {
        query = query.eq('category', category);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching meals:', error);
        throw error;
      }

      return data as DbMeal[];
    },
  });
}

export function useMeal(id: string) {
  return useQuery({
    queryKey: ['meal', id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('meals')
        .select('*')
        .eq('id', id)
        .maybeSingle();

      if (error) {
        console.error('Error fetching meal:', error);
        throw error;
      }

      return data as DbMeal | null;
    },
    enabled: !!id,
  });
}
